import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OutlinedInput from '@mui/material/OutlinedInput';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import DefaultDrawer from '../../../../components/default-drawer';
import moment from 'moment';
import { ISubmissionPublicationDetailResponse } from '../../../../model/sep/submission-publications/response/submissin-publication-detail-response';
import SubmissionPublicationAppService from '../../../../application/platform/sep/subimission-publication/subimission-publication-app-service';
import Button from '@mui/material/Button';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import { DefaultDialogProps } from '../../../../components/default-dialog';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { ISubmissionPublicationFileResponse } from '../../../../model/sep/submission-publications/response/submissin-publication-file-response';
import { IPublishingVehicleResponse } from '../../../../model/sdp/official-daily/response/publishing-vehicle-response';
import SaveIcon from '@mui/icons-material/Save';
import PublishIcon from '@mui/icons-material/Publish';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { IStatusSubimissonPublicationResponse } from '../../../../model/sep/submission-publications/response/status-submission-publication-response';
import { ISubmissionPublicationUpdateRequest } from '../../../../model/sep/submission-publications/request/submissin-publication-update-request';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export interface ISubmissionPublicationDetailProps {
    id: number | undefined;
    onClose?: () => void;
};

export default function SubmissionPublicationDetail({ props }: { props: ISubmissionPublicationDetailProps }) {
    const { showDialog, showLoading, showMessage } = useBaseLayout();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [detail, setDetail] = useState<ISubmissionPublicationDetailResponse>();
    const [updateParameters, setUpdateParameters] = useState<ISubmissionPublicationUpdateRequest>({});
    const [files, setFiles] = useState<ISubmissionPublicationFileResponse[]>([]);
    const [status, setStatus] = useState<IStatusSubimissonPublicationResponse[]>([]);
    const [tabIndex, setTabIndex] = useState(0);
    const colunsVehicles: GridColDef<IPublishingVehicleResponse>[] = [
        { field: 'id', headerName: 'Nº', width: 90, sortable: false },
        {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
            minWidth: 200, sortable: false
        }]
    const colunsFiles: GridColDef<ISubmissionPublicationFileResponse>[] = [
        { field: 'id', headerName: 'Nº', width: 90, sortable: false },
        { field: 'idRemessa', headerName: 'Nº', width: 90, sortable: false },
        {
            field: 'name',
            headerName: 'Arquivo',
            flex: 1,
            minWidth: 200, sortable: false
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 60,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <IconButton color="primary" aria-label="Baixar Arquivo" component="label" onClick={async () => {
                        showLoading({ open: true });
                        var result = await SubmissionPublicationAppService.downloadFile(params.row.idRemessa, params.row.id);
                        result.download();
                        showLoading({ open: false });
                    }}>
                        <DownloadIcon />
                    </IconButton>);

            }
        }
    ];

    const onClose = () => {
        if (props.onClose !== undefined) {
            props.onClose();
        }
        setOpen(false);
    }
    const handleOnChange = (e: any) => {
        let diagramerObservation = updateParameters.diagramerObservation;
        let statusId = updateParameters.statusId;

        if (e.target.name === "input-diagramerObservation") {
            diagramerObservation = e.target.value;
        }
        if (e.target.name === "select-status") {
            statusId = e.target.value;
        }

        setUpdateParameters(prevState => {
            return { ...prevState, diagramerObservation: diagramerObservation, statusId: statusId };
        });
    };


    useEffect(() => {
        (async () => {
            if (props.id !== undefined) {
                const details = await SubmissionPublicationAppService.getById(props.id);
                setDetail(details);

                if (details !== undefined) {
                    setUpdateParameters(prevState => {
                        return { ...prevState, diagramerObservation: details.diagramerObservation, statusId: details.statusId, id: details.id };
                    });
                }

                const files = await SubmissionPublicationAppService.listFiles(props.id);
                setFiles(files);

                setOpen(true);

                const status = await SubmissionPublicationAppService.listStatus();
                setStatus(status);

                setTabIndex(0);
            }
        })();
    }, [props.id]);


    const actions = () => {
        return (
            <React.Fragment>
                <Button variant="contained" onClick={async () => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa remessa de publicação?",
                        onYesClick: () => {
                            (async () => {
                                showLoading({ open: true });
                                await SubmissionPublicationAppService.update(updateParameters);
                                showLoading({ open: false });
                                showMessage({ message: "Dados salvo com sucesso!", open: true });
                            })();
                        }
                    } as DefaultDialogProps);


                }}
                    endIcon={<SaveIcon />}>Salvar</Button>
                {detail?.statusId === 1 && (
                    <Button variant="contained" onClick={() => {
                        showDialog({
                            open: true,
                            message: "Deseja realmente publicar essa remessa de publicação?",
                            onYesClick: () => {
                                navigate(`/diario-oficial/publicar/${props.id}`);
                            }
                        } as DefaultDialogProps);
                    }} endIcon={<PublishIcon />}>Publicar</Button>)
                }

            </React.Fragment >
        )
    }

    const handleTabChange = (event: any, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    return (
        <DefaultDrawer isOpen={open} title={`Detalhes da Remessa de Publicação Nº ${props.id}`} onClose={onClose}
            actions={() => {
                return actions();
            }}
        >
            <Grid container lg={12}
                sm={12}
                xl={12} spacing={2}>
                <Grid item lg={3}
                    sm={3}
                    xl={3}>
                    <InputLabel>Nº Remessa</InputLabel>
                    <OutlinedInput

                        disabled
                        fullWidth
                        value={detail?.id}
                    />
                </Grid>
                <Grid item lg={3}
                    sm={3}
                    xl={3}>
                    <InputLabel>Status</InputLabel>
                    <Select fullWidth name="select-status" value={updateParameters?.statusId} onChange={handleOnChange}>
                        {status.map((element) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}
                    </Select>

                </Grid>
                <Grid item lg={3}
                    sm={3}
                    xl={3}>
                    <InputLabel>Enviada em</InputLabel>
                    <OutlinedInput
                        fullWidth
                        disabled
                        value={moment(detail?.sendDate).format("DD/MM/yyyy HH:mm:ss")}
                    />
                </Grid>
                <Grid item lg={3}
                    sm={3}
                    xl={3}>
                    <InputLabel>Publicar em</InputLabel>
                    <OutlinedInput
                        fullWidth
                        disabled
                        value={moment(detail?.publishDate).format("DD/MM/yyyy")}
                    />
                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Titulo</InputLabel>
                    <OutlinedInput
                        fullWidth
                        disabled
                        value={detail?.title}
                    />
                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Enviada por</InputLabel>
                    <OutlinedInput
                        fullWidth

                        disabled
                        value={detail?.userSenderName}
                    />
                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Entidade</InputLabel>
                    <OutlinedInput
                        fullWidth
                        disabled
                        value={detail?.clientName}
                    />
                </Grid>

                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Observação/Instrução Remetente</InputLabel>
                    <TextField
                        multiline
                        fullWidth
                        rows={4}
                        disabled
                        value={detail?.instruction}
                    />

                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <Box>
                        <Box>
                            <Tabs value={tabIndex} onChange={handleTabChange}>
                                <Tab label="Arquivos Enviados" />
                                <Tab label="Veículos de Publicação" />
                                <Tab label="Observação/Pendências" />
                            </Tabs>
                        </Box>
                        <Box sx={{ padding: 2 }}>
                            {tabIndex === 0 && (
                                <Box>
                                    <Grid container lg={12}
                                        sm={12}
                                        xl={12}>
                                        <Grid item lg={12}
                                            sm={12}
                                            xl={12}>
                                            <DataGrid
                                                columns={colunsFiles}
                                                disableRowSelectionOnClick
                                                sx={{ height: '230px' }}
                                                columnVisibilityModel={{ id: false, idRemessa: false }}
                                                initialState={{ pagination: { paginationModel: { pageSize: files.length, page: 0 } } }}
                                                rows={files}
                                                pagination={true}
                                                autoPageSize={false}
                                                pageSizeOptions={[]} />
                                        </Grid>
                                        <Grid item lg={12}
                                            sm={12}
                                            xl={12} sx={{
                                                mt: 1,
                                                display: 'flex',
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-end"

                                            }}>
                                            <Button variant="contained" onClick={async () => {
                                                if (detail !== undefined) {
                                                    showLoading({ open: true });
                                                    var fileDownload = await SubmissionPublicationAppService.downloadFiles(detail.id);
                                                    fileDownload.download();
                                                    showLoading({ open: false });
                                                }
                                            }} endIcon={<DownloadIcon />}>Baixar Todos</Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            )}
                            {tabIndex === 1 && (
                                <Box>
                                    <DataGrid
                                        columns={colunsVehicles}
                                        disableRowSelectionOnClick
                                        sx={{ height: '250px' }}
                                        columnVisibilityModel={{ id: false }}
                                        initialState={{ pagination: { paginationModel: { pageSize: detail?.publishingVehicles?.length || 1, page: 0 } } }}
                                        rows={detail?.publishingVehicles}
                                        pagination={true}
                                        autoPageSize={false}
                                        pageSizeOptions={[]} />
                                </Box>
                            )}
                            {tabIndex === 2 && (
                                <Box>
                                    <FormControl fullWidth>
                                        <TextField
                                            multiline
                                            name='input-diagramerObservation'
                                            rows={6}
                                            onChange={handleOnChange}
                                            value={updateParameters?.diagramerObservation !== undefined ? updateParameters?.diagramerObservation : ""}
                                        />
                                    </FormControl>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </DefaultDrawer>
    );
}
